import {
  BuyerCookieService,
  clearLocalStoragePreserveLocks,
} from '@diamond/shared/utils';
import { clearNooRegistrationStatusToken } from '@diamond/sol-buyer/utils';
import { QueryClient } from '@tanstack/react-query';

import { clearPwaSessionCaches } from '../pwa/clearPwaSessionCaches';
import {
  useAuthStore,
  useCartStore,
  useShipToStore,
  useVoucherStore,
} from '../stores';

export async function clearBuyerSession(queryClient: QueryClient) {
  let failed = false;
  const attempt = (effect: () => void) => {
    try {
      effect();
    } catch {
      failed = true;
    }
  };
  attempt(() => useAuthStore.getState().resetSession());
  attempt(() =>
    useShipToStore.setState({
      selectedShipToId: '',
      selectedShipToDc: '',
      availableShipTo: [],
      selectedShipTo: null,
    })
  );
  attempt(() =>
    useCartStore.setState({
      cartItems: [],
      cartRecord: {},
      promoRecord: {},
      freeGoodsPromoRecord: {},
      originalFreeGoodsPromos: {},
      discountPromoRecord: {},
      productsRecord: {},
      productDetails: {},
      pendingAutoSelectProductIds: [],
    })
  );
  attempt(() =>
    useVoucherStore.setState({ appliedVouchers: [], pendingVouchers: [] })
  );
  attempt(clearLocalStoragePreserveLocks);
  attempt(() => clearNooRegistrationStatusToken());
  attempt(() => BuyerCookieService.clearAllAuthCookies());
  try {
    await queryClient.cancelQueries();
  } catch {
    failed = true;
  }
  attempt(() => queryClient.clear());
  try {
    await clearPwaSessionCaches();
  } catch {
    failed = true;
  }
  if (failed) throw new Error('Buyer session cleanup incomplete');
}
